// @ts-nocheck
import * as Types from '@instamenu/data-access-stats';

import gql from 'graphql-tag';
export type StatsOverviewFieldsFragment = { __typename?: 'RestaurantStats', grossSales: number, loyaltyComps: number, grossSubtotal: number, netSales: number, netSalesRefunds: number, netTotal: number, giftCardSales: number, surchargeAmount: number, tax: number, tips: number, totalDiscounts: number, merchantFee: number, processingFee: number, deliveryFee: number, invoiceNetTotal: number, cashPayments: number, cashRoundingAdjustment: number, giftCardPayments: number, salesTaxWithheld: number, expectedPayout: number, numOrders: number, averageSale: number, averageTip: number, averageTipPercent: number, externalOrderTotalsBySource: Array<{ __typename?: 'ExternalOrderTotal', sourceLabel: string, amount: number }>, restaurants: Array<{ __typename?: 'Restaurant', id: string, hasActiveStreamLocationConnection: boolean }> };

export const StatsOverviewFieldsFragmentDoc = gql`
    fragment statsOverviewFields on RestaurantStats {
  grossSales
  loyaltyComps
  grossSubtotal
  netSales
  netSalesRefunds
  netTotal
  giftCardSales
  surchargeAmount
  tax
  tips
  totalDiscounts
  merchantFee
  processingFee
  deliveryFee
  invoiceNetTotal
  cashPayments
  cashRoundingAdjustment
  giftCardPayments
  salesTaxWithheld
  expectedPayout
  externalOrderTotalsBySource {
    sourceLabel
    amount
  }
  restaurants {
    id
    hasActiveStreamLocationConnection
  }
  numOrders
  averageSale
  averageTip
  averageTipPercent
}
    `;